module.exports = __webpack_public_path__ + "img/electric-bike3.d23abab1.svg";